import type { ActionCard } from '@littlebird/sdk';

const DAY_MS = 24 * 60 * 60_000;

// History keeps its open card apart from the Feed's, so one card can be open in each
export const historyIdOf = (cardId: string) => `history:${cardId}`;

// When the card left the Feed for History
export const leftAtOf = ({ card }: { readonly card: ActionCard }): Date =>
  card.resolvedAt ?? card.dismissedAt ?? card.updatedAt;

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

// History groups its rows under day headings, so a row carries no time
export function historyDayLabel(date: Date, now: Date = new Date()): string {
  // Rounded, since a day that crosses a daylight-saving change is 23 or 25 hours long
  const daysAgo = Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS);
  if (daysAgo === 0) return 'Today';
  if (daysAgo === 1) return 'Yesterday';
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}
